import { Card, Group, Image, MantineTheme, Tooltip } from "@mantine/core";
import { ReactNode } from "react";
import { API_URL, APP_ID } from "../../../config";

export function DatosServiciosGestionViewColumnsOverrides(theme: MantineTheme) {
    return {
        6: {
            render: (value: unknown) => {
                const val = (value as string);
                if (val.startsWith('*')) {
                    const result = val.replace('*', '').split('--');

                    return (
                        <Group align="flex-start" spacing="xs">
                            {result.map((img, index) => (
                                <Tooltip label=
                                    {
                                        <Card>
                                            <Image
                                                key={index}
                                                src={`${API_URL}/${APP_ID}/serve/${img.replace('*', '')}`}
                                                alt={`Imagen ${index + 1}`}
                                                maw="600px"
                                                mt="auto"
                                            />
                                        </Card>
                                    }>
                                    <Image
                                        key={index}
                                        src={`${API_URL}/${APP_ID}/serve/${img.replace('*', '')}`}
                                        alt={`Imagen ${index + 1}`}
                                        maw="30px"
                                        mt="auto"
                                    />
                                </Tooltip>
                            ))}
                        </Group>
                    );
                }
                return val.replace('--', ' ') as ReactNode;
            }
        }
    }
}